import angular from 'angular';
import { includes, get } from 'lodash';
import '../../components/status';
import '../../services/display';
import 'angular-ui-tree';

const module = angular.module('whyline.modals.display', [
  'whyline.components.status',
  'whyline.services.display',
  'ui.tree',
]);

const DisplayModalController = ($scope, $timeout, $uibModalInstance, $translate, NotificationService, DisplayService, displayId, currentPlace) => {
  'ngInject';

  $scope.place = currentPlace;
  $scope.itemsPopulated = {};
  const populateAlreadyShown = () => {
    $scope.itemsPopulated = Object.assign({},
      $scope.display.areasPopulated,
      $scope.display.linesPopulated
    );
  };

  const validate = () => {
    const name = $scope.display.name;
    const topPosition = $scope.display.topPosition.enabled;
    const bottomPosition = $scope.display.bottomPosition.enabled;
    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_display_name'));
      return false;
    }
    if (name.length < 2) {
      NotificationService.Warning($translate.instant('min_char_display_name'));
      return false;
    }
    if (!$scope.display.lines.length && !$scope.display.areas.length) {
      NotificationService.Warning($translate.instant('select_min_fila'));
      return false;
    }
    if (!topPosition && !bottomPosition) {
      NotificationService.Warning($translate.instant('mandatory_display_position'));
      return false;
    }
    return true;
  };

  const dismissOnError = err => {
    if ([401, 403, 404].indexOf(err.status) >= 0) {
      $uibModalInstance.close('cancel');
    }
    DisplayService.GetAllAsPromiseFromServer();
  };

  $scope.display = {
    lines: [],
    areas: [],
    linesPopulated: {},
    areasPopulated: {},
    hasMultimedia: true,
    showAreaName: true,
    topPosition: {
      enabled: true,
      showSubscription: 'called'
    },
    bottomPosition: {
      enabled: false,
      showSubscription: 'waiting'
    }
  };

  if (displayId) {
    DisplayService.GetOnePopulatedAsPromiseFromServer(displayId)
      .then(display => {
        $timeout(() => {
          $scope.display = DisplayService.Copy(display);
          const topConfig = get(display, 'topPosition', { enabled: true, showSubscription: 'called' });
          const bottomConfig = get(display, 'bottomPosition', { enabled: true, showSubscription: 'waiting' });
          $scope.display.topPosition = topConfig;
          $scope.display.bottomPosition = bottomConfig;
          populateAlreadyShown();
        });
      })
      .catch(err => dismissOnError(err));
  }

  $scope.save = () => {
    if (validate()) {
      if (displayId) {
        return DisplayService.Update($scope.display)
          .then(() => {
            NotificationService.Success($translate.instant('display_update_sicc'));
            $uibModalInstance.close('cancel');
          })
          .catch(err => dismissOnError(err));
      }

      return DisplayService.Create($scope.display).then(() => {
        NotificationService.Success($translate.instant('display_create_succ'));
        $uibModalInstance.close('cancel');
      })
        .catch(err => dismissOnError(err));
    }
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.selectLine = selection => {
    const id = selection._id;

    if (selection.type === 'line') {
      if (!includes($scope.display.lines, selection._id)) {
        $scope.display.lines.push(id);
        $scope.display.linesPopulated[id] = selection;
        populateAlreadyShown();
      }
    } else if (selection.type === 'area') {
      if (!includes($scope.display.areas, selection._id)) {
        $scope.display.areas.push(id);
        $scope.display.areasPopulated[id] = selection;
        populateAlreadyShown();
      }
    }
  };

  $scope.remove = id => {
    const lineIndex = $scope.display.lines.indexOf(id);
    if (lineIndex >= 0) {
      $scope.display.lines.splice(lineIndex, 1);
      $scope.display.linesPopulated[id] = undefined;
      Reflect.deleteProperty($scope.display.linesPopulated, id);
      populateAlreadyShown();
    }
    const areaIndex = $scope.display.areas.indexOf(id);
    if (areaIndex >= 0) {
      $scope.display.areas.splice(areaIndex, 1);
      $scope.display.areasPopulated[id] = undefined;
      Reflect.deleteProperty($scope.display.areasPopulated, id);
      populateAlreadyShown();
    }
  };

  $scope.changeShowSubscription = (subscriptionToShow, position) => {
    switch (position) {
      case 'topPosition': {
        $scope.display[position].showSubscription = subscriptionToShow;
        if ($scope.display['bottomPosition'].showSubscription = subscriptionToShow) {
          $scope.display['bottomPosition'].showSubscription = subscriptionToShow === 'called' ? 'waiting' : 'called';
        }
      }
        break;
      case 'bottomPosition': {
        $scope.display[position].showSubscription = subscriptionToShow;
        if ($scope.display['topPosition'].showSubscription = subscriptionToShow) {
          $scope.display['topPosition'].showSubscription = subscriptionToShow === 'called' ? 'waiting' : 'called';
        }
      }
        break;
    }
  }
};

module.exports = module.controller('DisplayModalController', DisplayModalController);
